import React from 'react';
import CollapsibleCard from 'components/UI/CollapsibleCard';
import PropTypes from 'prop-types';
import TravelersList from './AssistantList/Loadable';

function AssistantInfoWidget({ pingState })
{
    return (
        <CollapsibleCard
            pingState={pingState}
            title="Assistant Info"
            storeId="assistant_info_profile"
        >
            <TravelersList />
        </CollapsibleCard>
    );
}

AssistantInfoWidget.defaultProps = {
    pingState: false,
};

AssistantInfoWidget.propTypes = {
    pingState: PropTypes.bool,
};

export default AssistantInfoWidget;
